import { render } from "./zscqyyfw.vue?vue&type=template&id=7089595a&scoped=true"
import script from "./zscqyyfw.vue?vue&type=script&lang=js"
export * from "./zscqyyfw.vue?vue&type=script&lang=js"

import "./zscqyyfw.vue?vue&type=style&index=0&id=7089595a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7089595a"]])

export default __exports__